export const FATURA_LOAD = "FATURA_LOAD";
export const FATURA_LOAD_ORDER = "FATURA_LOAD_ORDER";
export const FATURA_ACCEPT_ORDER = "FATURA_ACCEPT_ORDER";
